enum NotificationId {
	CONTRACT_SUSPENDED = 'contractSuspended',
	PAYMENT_PENDING = 'paymentPending',
	IR_DEMONSTRATIVE = 'irDemonstrative',
	REFERRALS = 'referrals',
	DIGITAL_BILL = 'digitalBill',
	REGISTRATION_DATA_UPDATE = 'registrationDataUpdate',
}

export {NotificationId};
